export default __webpack_public_path__ + "static/media/locationhistory.1e9ed6b3.png";